import React from "react";
import InssureLogo from "../../Components/InssureLogo";

const SignUpConflictDialog = ({ open, title, message, onClose, onLogin }) => {
  if (!open) return null;

  return (
    <div className="ems-org-overlay" role="dialog" aria-modal="true">
      <div className="ems-org-picker">
        <div className="ems-org-picker-hd">
          <InssureLogo className="ems-auth-brand-logo" />
          <h3 className="ems-org-picker-h">{title}</h3>
          <p className="ems-org-picker-sub">{message}</p>
        </div>
        <div className="ems-org-foot">
          <button type="button" className="ems-btn ems-ghost" onClick={onClose}>
            Close
          </button>
          <button type="button" className="ems-btn ems-primary" onClick={onLogin}>
            Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export const getSignupConflict = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data || {};
  const message = String(data.message || data.error || "").trim();
  const errors = data.errors || {};
  const phoneErrors = errors.phone_number || errors.phone;
  const emailErrors = errors.email;

  const emailConflict = {
    type: "email",
    title: "Email Already Registered",
    message:
      "This email is already registered. Please use a different email or log in to your existing account.",
    fieldError: "This email is already registered",
  };

  const phoneConflict = {
    type: "phone",
    title: "Phone Number Already Registered",
    message:
      "This phone number is already registered. Please use a different number or log in to your existing account.",
    fieldError: "This phone number is already registered",
  };

  if (
    status === 409 &&
    (/user already exist/i.test(message) ||
      /user already verified/i.test(message) ||
      /email.*already/i.test(message))
  ) {
    return emailConflict;
  }

  if (
    status === 409 &&
    /phone number already exists/i.test(message)
  ) {
    return phoneConflict;
  }

  if (status === 422 && phoneErrors) {
    const phoneMessage = Array.isArray(phoneErrors) ? phoneErrors[0] : phoneErrors;
    if (/already|taken|exists/i.test(String(phoneMessage))) {
      return {
        type: "phone",
        title: "Phone Number Already Registered",
        message:
          "This phone number is already registered. Please use a different number or log in to your existing account.",
        fieldError: "This phone number is already registered",
      };
    }
  }

  if (status === 422 && emailErrors) {
    const emailMessage = Array.isArray(emailErrors) ? emailErrors[0] : emailErrors;
    if (/already|taken|exists/i.test(String(emailMessage))) {
      return {
        type: "email",
        title: "Email Already Registered",
        message:
          "This email is already registered. Please use a different email or log in to your existing account.",
        fieldError: "This email is already registered",
      };
    }
  }

  return null;
};

export default SignUpConflictDialog;
